import Link from "next/link";
import { scrollToElement } from "@/utils/scrollToElement";

type BlockStorageData = {
  storage: string;
  outbound: string;
  price: string;
};

export const BLOCK_STORAGE_DATA: BlockStorageData[] = [
  {
    storage: "10 GB",
    outbound: "Unlimited",
    price: "$1",
  },
  {
    storage: "20 GB",
    outbound: "Unlimited",
    price: "$2",
  },
  {
    storage: "40 GB",
    outbound: "Unlimited",
    price: "$4",
  },
  {
    storage: "80 GB",
    outbound: "Unlimited",
    price: "$8",
  },
  {
    storage: "160 GB",
    outbound: "Unlimited",
    price: "$16",
  },
  {
    storage: "320 GB",
    outbound: "Unlimited",
    price: "$32",
  },
  {
    storage: "640 GB",
    outbound: "Unlimited",
    price: "$64",
  },
  {
    storage: "1280 GB",
    outbound: "Unlimited",
    price: "$128",
  },
  {
    storage: "2560 GB",
    outbound: "Unlimited",
    price: "$256",
  },
  {
    storage: "5120 GB",
    outbound: "Unlimited",
    price: "$512",
  },
  {
    storage: "10240 GB",
    outbound: "Unlimited",
    price: "$1024",
  },
];

export const TABLE_HEADER = {
  title: "NVME Block Storage",
  subTitle:
    "We have a variety of storage options available for you to choose from to meet your needs.",
};

export const TableFooterConstants = {
  text1: (
    <>
      At this time, All Block Storage services can be subscribed through special orders.{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
      >
        Contact Us
      </Link>{" "}
      for more information and to get a deeper understanding of our services.
    </>
  ),
};
